import React from 'react'

import { useTranslation } from 'react-i18next'

export const SearchNoResults: React.FC = () => {
  const { t } = useTranslation()
  return (
    <div className="card dxp-search-results-card">
      <div className="box-error">
        <div className="spaceman-sad"></div>
        <h3>{t('search.noResults.title')}</h3>
        <p className="text-muted">{t('search.noResults.subtitle')}</p>
      </div>
    </div>
  )
}
